import React from 'react';
// import tennis from "../../assets/tennis.mp4";

const NotFound: React.FC = () => {
  return (
    <div>
      <h1>Page Not Found</h1>
      {/* <video
        width="100%"
        height="auto"
        autoPlay
        loop
        muted
        playsInline
        style={{ display: "block" }}
        > */}
        {/* <source src={tennis} type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      page under construction
    </div>
  );
};

export default NotFound;
